import React from "react";
import "../styles/register.css";

const RegistrationSuccess = () => {
  return (
    <div className="register-page">
      <div className="register-info">
        <h1>🎉 Cadastro concluído!</h1>
        <p>Sua conta foi criada com sucesso.</p>
        <p>Você já pode fazer login usando suas credenciais.</p>
        <a href="/login" className="btn">Ir para o Login</a>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
